import "../style/main.css";

// Individual imports for each component used in this sample
import "@arcgis/map-components/components/arcgis-map";

import { useEffect, useState } from "react";
import DefaultWidgets from "./widgets/DefaultWidgets";
import { useSelector } from "react-redux";

// this is to define what are the properties we're configuring for the component, rather than doing a props:any setup
interface MapProps {
  mapItem: string
  referenceId?: string
  children?: any
  priorityFilter?: string[]
  directionFilter?: 'forward' | 'reverse'
  onViewReady?: (event: Event) => void; // Add this line
  onViewChange?: (event: Event) => void; // Add this line
}

const MapComponent = ({
  mapItem,
  referenceId = '',
  children,
  priorityFilter = [],
  directionFilter,
  onViewReady, // Accept as prop
  onViewChange
}: MapProps) => {
  const [mapView, setView] = useState<any>({});
  const [map, setMap] = useState<any>({});

  const [featureLayer, setFeatureLayer] = useState<any>(null);
  const selectedPriority = useSelector((state: any) => state.global.selectedPriority);

  let view: any;

  const handleViewReady = (event: Event) => {
    view = ((event as any).target.view);
    const map = ((event as any).target.map);

    // map.layers.forEach((layer: any) => {
    //   console.log("Layer:", layer.id, layer.title);
    // });
    // console.log("Map layers:", map.layers);
    const layer = map.layers.find((l: any) => l.title === "Formation Widening Priorties "); // the title layer has a white space at the end, be careful when matching the name
    async function fetch() {
      const layerView = mapView?.layerViews?.items?.find((l: any) => l.layer.title === "Grades (Emerald to Springsure)");
      const featureSet = await layerView?.queryFeatures({
        geometry: mapView.extent
      });
      // console.log('mapView', mapView);
      // console.log('layerViews', mapView.layerViews);
      // console.log('layerView', layerView);
      // console.log(featureSet?.features?.length);  
    }
    fetch()
    setFeatureLayer(layer);

    setView(view)
    setMap(map)
    // // Call external handler if provided
    // if (onViewReady) {
    //   onViewReady(event);
    // }
  }

  useEffect(() => {
    if (!featureLayer) return;
    const conditions: string[] = [];
    if (priorityFilter.length > 0) {
      conditions.push(
        `priority IN (${priorityFilter
          .map((p: any) => `'${p}'`)
          .join(", ")})`
      );
    }
    const where =
      conditions.length > 0
        ? conditions.join(" AND ")
        : "1=1";
    featureLayer.definitionExpression = where;
  }, [featureLayer, priorityFilter, directionFilter]);

// configured to render children only if they are provided as input
  return (
    <arcgis-map
      id={referenceId}
      item-id={mapItem}
      onarcgisViewReadyChange={onViewReady || handleViewReady}
      onarcgisViewChange={onViewChange || handleViewReady}
    >
      <DefaultWidgets />
      {children &&
        <>
          {children}
        </>
      }
      {/* <Legend />
      <BasemapGallery /> */}
    </arcgis-map>
  );
}

export default MapComponent
